import * as ActionTypes from 'actions/beneficiaryUpload'

const initialState = {
  isFetching: false,
  isError: false,
  fetched: false,
  beneficiaryLocked: '1',
  beneficiaryUploaded: [],
}

// Updates error message to notify about the failed fetches.
export default function beneficiaryUpload(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.BENEFICIARY_UPLOAD_GET:
      return {
        ...state,
        isFetching: true,
      }
    case ActionTypes.BENEFICIARY_UPLOAD_RECEIVED:
      return {
        ...state,
        isFetching: false,
        fetched: true,
        beneficiaryUploaded: action.uploads,
        beneficiaryLocked: action.locked,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/beneficiaryUpload.js